import React from "react";
import { func, bool, string } from "prop-types";
import { Row, Col, Alert } from "react-bootstrap";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import blueInfoIcon from "resources/images/blue-info.svg";

const AutoRenewalToggle = ({
  allowUpdateAutoRenewal,
  handleUpdateAutoRenewal,
  isAutoRenewalEnabled,
  showCannotUpdateAutoRenewalMessage,
  updatingAutoRenewal,
  updatingAutoRenewalStatus,
}) => (
  <>
    <Row>
      <Col lg={12} md={12} sm={12}>
        <hr />
      </Col>
    </Row>
    <Row>
      <Col
        lg={10}
        md={10}
        sm={10}
        style={{
          opacity: allowUpdateAutoRenewal ? "1" : "0.6",
        }}
      >
        <h4 className="text-header">Auto-Renewal</h4>
        {updatingAutoRenewalStatus === "fail" ? (
          <div className="error-message mb-2">
            Something went wrong when updating your auto-renewal option, please
            try again later. If the issue persists, please contact your Account
            Manager.
          </div>
        ) : null}
        <p>
          By toggling on the auto-renewal option, you are granting Criteria
          permission to automatically renew your account when your subscription
          period expires, ensuring uninterrupted access to our services.
        </p>
      </Col>
      <Col
        lg={2}
        md={2}
        sm={2}
        className="text-right"
        style={{ marginTop: "30px" }}
      >
        <Toggle
          id="autoRenewal"
          icons={false}
          disabled={!allowUpdateAutoRenewal || updatingAutoRenewal}
          checked={isAutoRenewalEnabled}
          onChange={handleUpdateAutoRenewal}
        />
      </Col>
      {showCannotUpdateAutoRenewalMessage ? (
        <Col lg={12} md={12} sm={12}>
          <Alert
            style={{ color: "#1f8e93", background: "#eaf9fa" }}
            className="d-flex mb-0"
          >
            <div>
              <img
                alt="info"
                src={blueInfoIcon}
                height="16px"
                width="16px"
                className="mr-3"
              />
            </div>
            <div className="flex-grow-1">
              You cannot adjust auto-renewal status within 30 days of renewal.
              If you have any questions or concerns, please contact your Account
              Manager.
            </div>
          </Alert>
        </Col>
      ) : null}
    </Row>
  </>
);

AutoRenewalToggle.propTypes = {
  allowUpdateAutoRenewal: bool,
  handleUpdateAutoRenewal: func,
  isAutoRenewalEnabled: bool,
  showCannotUpdateAutoRenewalMessage: bool,
  updatingAutoRenewal: bool,
  updatingAutoRenewalStatus: string,
};

export default AutoRenewalToggle;
